<template>
  <div v-if="homeData" class="Partners">
    <div v-if="$root.globalData" class="Partners__title">
      <h4>{{ $root.globalData.keys.partners_title }}</h4>
      <p>{{ $root.globalData.keys.partners_text }}</p>
    </div>
    <div id="partnerSlider" class="swiper-container">
    <div class="swiper-wrapper">

        <div
        class="swiper-slide partners__logo"

          v-for="item in homeData.partners"
          :key="item.id"
        >
          <img class="partnerLogoImage" :src="item.image" :alt="item.title" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// // optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import Logo1 from "../../assets/images/logo1.png";
import Logo2 from "../../assets/images/logo2.png";
import Logo3 from "../../assets/images/logo3.png";
import Logo4 from "../../assets/images/logo4.png";
import Swiper from "swiper/swiper-bundle.min";

import Logo5 from "../../assets/images/logo5.png";
import Logo6 from "../../assets/images/logo6.png";

let breakpoints = {
  300: {
    slidesPerView: 1,
    spaceBetween: 4
  },
  370: {
    slidesPerView: 1,
    spaceBetween: 2
  },
  500: {
    slidesPerView: 2,
    spaceBetween: 1
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 1
  },
  1200: {
    slidesPerView:5,
    spaceBetween: 10
  }
};
export default {

methods:{
    initSlider(kill = false) {
      this.$root.initSwiper("recommendedProductSlider1", kill, () => {
        try {
          if (this.slider) {
            this.slider.destroy();
          }
        } catch (e) {}
        this.slider = new Swiper("#partnerSlider.swiper-container", {
          spaceBetween: 1,
          //   centeredSlides: true,
          loop: false,
          speed: 500,
         
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
          autoplay: true,
          
          breakpoints
        });
      });
    },
},
  computed: {
    modules() {
      return [Autoplay];
    },
    homeData() {
      return this.$store.getters.getHomeData;
    }
  },
  data() {
    return {
          slider:null,

      boximages: 5,
      logos: [Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo2, Logo3, Logo4],
      title: "همکاران ما ",
      text: "لورم ایپسوم متن ساختگی با تولید سدگی نامفهوم",

      breakpoints: {
        1025: {
          slidesPreview: 2,
          spaceBetween: 30
        },
        768: {
          slidesPreview: 2,
          spaceBetween: 30
        },
        420: {
          slidesPreview: 2,
          spaceBetween: 30
        }
      }
    };
  },
  mounted() {
    this.initSlider(false);

  },

  watch:{
    homeData(){
      this.initSlider(true);

    }
  }
};
</script>

<style scoped>
.BlogSlider {
  display: flex;
}
.Partners {
  padding-top: 5rem;
  overflow: hidden;
}
.Partners__title h4 {
  font-size: 25px;
  margin-bottom: 1rem;
}

.Partners__title p {
  font-size: 18px;
}

.partners__logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
  width:320px;
  height:250px;
}
@media (max-width: 768px){

  .partners__logo img{
    object-fit: unset !important;
  } 
}
.partners__logo img{
  width:100%;
  /* object-fit: cover; */
}
.parents__logo__box {
  margin: 0 2rem;
  filter: grayscale(30);
  opacity: 0.5;
}

/* .partnerLogoImage {
  filter: grayscale(20);
} */
</style>
<style>
.ltrStyle .Partners__title h4,
.ltrStyle .Partners__title p {
  direction: ltr;
}
</style>
